import { applyPromotionsToLineItems } from './promotionPricing';

// Preview a new weighing against the existing sale, using the same calculator
// that creates the checkout payload. Existing readings can qualify together.
export const previewPosWeighing = ({ items = [], item, promotions = [], now }) => {
  if (!item || !(Number(item.quantity) > 0)) return null;
  return applyPromotionsToLineItems([...items, item], promotions, 'sale', { now }).at(-1);
};
